export const EstatusPagoEnum = Object.freeze({
    Pendiente: 1,
    Pagado: 2,
    Rechazado: 3,
    Cancelado: 4
});